import { DataContext } from "../DataContext";
import { useContext } from "react";
import styled from "styled-components";
import { renderSizeAbbreviationHTML } from "../utils";
import { ASSET_URL } from "../constants";

const ProductRow = styled.div`
  border-bottom: 1px solid var(--border);
  padding: 30px;
  .flex-col {
    display: flex;
    align-items: center;
    .product-image {
      min-width: 130px;
      min-height: 130px;
      img {
        max-width: 120px;
        max-height: 120px;
      }
    }
    .product-content {
      display: flex;
      width: 100%;
      line-height: 200%;
      .product-options {
        width: 50%;
        & > div {
          display: flex;
          align-items: center;
          .label {
            width: 90px;
            text-align: right;
            margin-right: 20px;
          }
          .value {
            font-weight: 700;
          }
        }
      }
      .product-price {
        display: flex;
        justify-content: flex-end;
        width: 50%;
        .value {
          margin-left: 20px;
          font-weight: 700;
          text-align: left;
          width: 40px;
        }
      }
      @media only screen and (max-width: 599px) {
        flex-direction: column;
        .product-options {
          width: 100%;
          & > div {
            display: flex;
            justify-content: space-between;
            position: relative;
            .label,
            .value {
              z-index: 1;
              background-color: var(--white);
            }
            .label {
              padding-right: 10px;
              text-align: left;
              width: initial;
              text-align: left;
              margin-right: 0;
            }
            .value {
              padding-left: 10px;
              text-align: right;
              font-weight: 700;
            }
            &::after {
              border: 1px dashed #dddddd;
              content: "";
              top: 50%;
              width: 100%;
              height: 1px;
              right: 0;
              display: block;
              position: absolute;
              z-index: 0;
            }
          }
        }
        .product-price {
          width: 100%;
          display: flex;
          justify-content: space-between;
          position: relative;
          .label,
          .value {
            z-index: 1;
            background-color: var(--white);
          }
          .label {
            padding-right: 10px;
            text-align: left;
            width: initial;
            text-align: left;
            margin-right: 0;
          }
          .value {
            padding-left: 10px;
            text-align: right;
            font-weight: 700;
            width: initial;
          }
          &::after {
            border: 1px dashed #dddddd;
            content: "";
            top: 50%;
            width: 100%;
            height: 1px;
            right: 0;
            display: block;
            position: absolute;
            z-index: 0;
          }
        }
      }
    }
    @media only screen and (max-width: 599px) {
      justify-content: space-between;
      .product-image {
        min-width: 100px;
        min-height: 100px;
        margin-right: 20px;
        img {
          max-width: 90px;
          max-height: 90px;
        }
      }
      .product-content {
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
  @media only screen and (max-width: 991px) {
    padding: 20px;
  }
`;

function CheckoutProduct(props) {
  const data = useContext(DataContext);
  const { id, quantity, size, position, design } = props.product;

  function findSelectedDesign(designName) {
    const designObj = data.designs.find((design) => design.designName === designName);
    return designObj;
  }

  const product = data.availableProducts.find((product) => {
    return id === product.id;
  });

  const designObject = findSelectedDesign(design);

  return (
    <ProductRow className={`${props.success && "success"}`}>
      <div className="flex-col">
        <div className="product-image border">
          <picture>
            <source srcset={`${ASSET_URL}/designs/small/${design}-logo.avif`} type="image/avif" />
            <img src={`${ASSET_URL}/designs/small/${design}-logo.gif`} width="120" />
          </picture>
        </div>
        <div className="product-content">
          <div className="product-options">
            <div>
              <div className="label">Shirt Size</div>
              <div className="value size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(size) }} />
            </div>
            <div>
              <div className="label">Position</div>
              <div className="value">{position}</div>
            </div>
            <div>
              <div className="label">Qty</div>
              <div className="value">{quantity}</div>
            </div>
          </div>
          <div className="product-price">
            <div className="label">Unit Price</div>
            <div className="value">${product.cost}</div>
          </div>
        </div>
      </div>
    </ProductRow>
  );
}

export default CheckoutProduct;
